export class ConfigModel {

    //Adding all stuff than are not stored Offline
    public key_mapping: string;
    public server_url: string;

}